import inputSaga from "./input/inputSaga";
import persistenceSaga from "./persistence/persistenceSaga";
import pricingSaga from "./pricing/pricingSaga";
import tempSaga from "./temp/tempSaga";
import { spawn } from "redux-saga/effects";

export default function* rootSaga() {
  yield spawn(persistenceSaga);
  yield spawn(inputSaga);
  yield spawn(pricingSaga);
  yield spawn(tempSaga);
}
